import LocationActionMenu, { LocationActionItem } from '../../Location/tabs/components/LocationActionMenu'

export interface HealthEntityActionMenuItem {
  label: string
  icon: string
  action: () => void
  disabled?: boolean
}

interface HealthEntityActionMenuProps {
  menuItems: HealthEntityActionMenuItem[]
  buttonClassName?: string
  buttonAriaLabel?: string
  contentClassName?: string
  className?: string
}

export default function HealthEntityActionMenu({
  menuItems,
  buttonClassName = 'p-button-text',
  buttonAriaLabel = 'Opciones',
  contentClassName = 'w-56',
  className = 'health-entity-action-menu-panel',
}: Readonly<HealthEntityActionMenuProps>) {
  if (!menuItems || menuItems.length === 0) {
    return null
  }

  const actionItems: LocationActionItem[] = menuItems.map((item) => ({
    label: item.label,
    icon: item.icon,
    action: item.action,
    disabled: item.disabled,
  }))

  return (
    <LocationActionMenu
      items={actionItems}
      buttonClassName={buttonClassName}
      ariaLabel={buttonAriaLabel}
      panelClassName={className}
      contentClassName={contentClassName}
    />
  )
}
